import { render, staticRenderFns } from "./groupableHeader.vue?vue&type=template&id=0b33e7e7&"
import script from "./groupableHeader.vue?vue&type=script&lang=js&"
export * from "./groupableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports